import { Box } from '@mui/material';
import * as htmlToImage from 'html-to-image';

export const exportHtmlToImage = (element) => {

  if (element) {

    const hiddenElements = element.querySelectorAll('.showcopyright');
    hiddenElements.forEach(el => el.style.display = 'block')

    htmlToImage.toPng(element, {
        backgroundColor: '#ffffff', // White background
        quality: 0.95,
        //filter: (node) => !node.classList?.contains('showcopyright')
      })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'chart.png';
        link.click();
      })
      .catch((error) => {
        console.error('Error generating image:', error);
      })
      .finally(() => {
        hiddenElements.forEach(el => el.style.display = 'none');
      });
  }
};
